<template>
	<div class="orderdetail">
		<cube-page type="orderdetail-view" title="订单详情">
			<div slot="content">
				<div class="orderitem">
					<div class="ordertitle">
						<p>订单号：{{list.order_no}}</p>
						<p class="colorred"></p>
					</div>
					<div class="ordemain">
						<div class="ordecontent">
							<div class="order">
								<van-image radius="8" width="88" height="90" :src="goods.image" />
								<div class="orderright">
									<p class="ordername ells">{{goods.goods_name}}</p>
									<p class="orderdec">{{goods.goods_attr}}</p>
									<div class="carddesc">
										<span>使用时间：</span>
										<span>{{list.use_date}}</span>
									</div>
								</div>
							</div>
							<div style="width: 80px; height: 80px;">
								<van-image v-show="list.master_write_code != ''" @click="imgShow(list.master_write_code)"
									width="80" height="80" :src="list.master_write_code" />
							</div>
						</div>
						<div class="orderfooter">
							<p class="ordernum"><span>下单数量：</span>{{goods.total_num}}</p>
							<div class="orderjj">
							<!-- 	<div class="item">总价¥<span class="price" v-html="decimalPoint(list.total_price)"></span>
								</div>
								<div class="item blodspan">
									实付款¥<span class="price" v-html="decimalPoint(list.pay_price)"></span>

								</div> -->
							</div>
						</div>
					</div>
				</div>
				<van-collapse v-model="activeNames">
					<van-collapse-item title="备注信息" name="1">
						<div class="itembox">
							<div class="itemright">
								 <van-cell title="备注" :value="list.remarks" />
							<!-- 	<div class="itemxx">
									联系人：
									<span>{{list.guide_name }}</span>
								</div>
								<div class="itemxx">
									联系电话：
									<span>{{list.guide_mobile}}</span>
								</div> -->
							</div>
						</div>
					</van-collapse-item>
					<van-collapse-item title="客户信息" name="2">
						<div class="itembox" v-for="(item,index) in list.meta" :key="index">
							<div class="itemright">
								<div class="itemxx">
									联系人：
									<span>{{item.contacts}}</span>
								</div>
								<div class="itemxx">
									手机号：
									<span>{{item.telephone}}</span>
								</div>
								<div class="itemxx" v-if="item.IDCard">
									证件号：
									<span>{{item.IDCard}}</span>
								</div>
								<div class="itemxx">
									核销码：
									<span>{{item.code}}</span>
								</div>
								<div class="itemxx" v-if="item.code">
									核销状态：
									<span>{{item.use_status_text}}</span>
								</div>
								<div class="itemxx">
									核销次数：
									<span>{{item.use_num}}</span>
								</div>
								<div class="itemxx" v-if="item.last_use_time">
									核销时间：
									<span>{{item.last_use_time}}</span>
								</div>
							</div>
							<div class="itembtns"
								v-if="(list.order_status_cn=='待核销' || list.order_status_cn=='已完成')&& isnoShow==null">
								<van-button icon="qr" size="small" round type="info" plain @click="showQr(item)">核销码
								</van-button>
							</div>
						</div>
					</van-collapse-item>
				</van-collapse>
			</div>
		</cube-page>
		<van-popup v-model="qrshow" round class="qrpopup" style="width: 80%;padding: 40px 0;">
			<div class="qrshow">
				<div class="imgcenter">
					<van-image :src="resData.code_url" alt="二维码" />
				</div>
				<p class="pm"><span>{{resData.code}}</span></p>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import CubePage from '../TP/cube-page.vue'
	import * as util from '@/utils/network'
	import {
		Toast,
		ImagePreview
	} from 'vant';

	export default {
		components: {
			CubePage,
		},
		data() {
			return {
				store: null,
				activeNames: ['1', '2'],
				active: 0,
				txshow: false,
				xgprice: '',
				id: this.$route.query.id,
				isUpdate: this.$route.query.update,
				isShop: this.$route.query.isshop,
				isnoShow: this.$route.query.noShow ? '1' : null,
				list: {},
				goods: {},
				detail: {
					address: {
						Area: {}
					},
				},
				disabled: false,
				gcfg: [],
				qrshow: false,
				resData: {}
			};
		},
		created() {
			console.log(this.id)
			this.getData()
		},
		methods: {
			imgShow(url) {
				ImagePreview([url]);
			},
			//获取核销码
			showQr(item) {
				let that = this;
				var url = "/addons/litestore/api.order/order_wirteoffcode"
				//这里直接调用网络接口
				util.post(url, {
						order_id: that.list.id,
						id: item.id
					},
					function(res) {
						that.resData = res.data
						that.qrshow = true
					},
				);
			},
			getData() {
				let that = this
				var url = "/addons/litestore/api.order/get_order_write"
				var parm = {
					id: that.id,
					goBack: 'true'
				}
				if (that.isShop != undefined) {
					parm = {
						store_id: that.store.id,
						id: that.id
					}
				}
				//这里直接调用网络接口
				util.get(url, parm,
					function(result) {
						console.log(result)
						that.list = result.data.order
						that.goods = result.data.order.goods[0]
						that.xgprice = result.data.pay_price
					},
					function(err) {
						console.log(err)
					}
				);

			},
			decimalPoint(val) {
				const splitPrice = (val || '0.00').split('.');
				const numb1 = splitPrice[0];
				var numb2 = '00';
				if (splitPrice.length > 1) {
					numb2 = splitPrice[1];
				}
				return `${numb1}.<span style="font-size: 12px; line-height: 12px;">${numb2}</span>`;
			},
		},
		watch: {
			"$store.state.gcfg"() {
				this.gcfg = this.$store.getters.getGcfg
			},
			"$store.state.shop"() {
				this.store = this.$store.getters.getShop
			}
		},
	}
</script>
<style lang="less" scoped="scoped">
	@import url("../../assets/css/order.css");
	@import url("../../assets/css/listboxless.less");

	.ordemain {
		padding: 15px;

		.orderfooter {
			height: 30px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 12px;

			.ordernum {}

			.orderjj {
				display: flex;
			}

			.item {
				padding-left: 15px;
				color: #aaabaf;

				.price {
					font-size: 15px;
					font-weight: 600;
				}
			}

			.blodspan {
				color: #000;
				font-weight: 600;
			}
		}
	}

	.ordecontent {
		display: flex;
		justify-content: space-between;
		align-items: center;

		.order {
			flex: 1;
			width: 0;
			flex-shrink: 0;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.orderright {
				flex: 1;
				width: 0;
				flex-shrink: 0;
				padding: 0 10px;

				.ordername {
					font-size: 14px;
				}

				.orderdec {
					padding: 5px 0;
					font-size: 13px;
				}

				.carddesc {
					font-size: 12px;
				}

				.orderp {
					height: 28px;
					display: flex;
					justify-content: space-between;
					align-items: center;

					.ordernum {
						font-size: 12px;
						color: #969799;
					}

					.dj {
						span {
							font-size: 12px;
						}
					}
				}
			}
		}
	}

	.van-cell {
		background-color: #FFFFFF;
	}

	.van-collapse {
		padding-bottom: 80px;
	}

	.itembox {
		display: flex;
		align-items: center;
		padding: 5px 0;

		.itemleft {
			width: 60px;
		}

		.itemright {
			flex: 1;

			.itemxx {
				line-height: 25px;

				span {
					color: #333;
				}
			}
		}

		.itembtns {
			width: 78px;
		}
	}

	.itembox+.itembox {
		border-top: 1px solid #e5e5e5;
	}
</style>
